import { createContext, useContext } from "react";
import { BOARD_TAB_STOP_ATTRIBUTE } from "./boardSensors";

/** Whether focus is in the `BoardCard` around, set by the card. */
export const BoardCardFocusContext = createContext(false);

/**
 * Props for a control inside a `BoardCard` that Tab reaches from its own card
 * only: in the Tab order while focus is in the card, and kept by the card
 * when the keyboard lands on it. Elsewhere the focused card stays the board's
 * one Tab stop.
 */
export const useBoardCardTabStop = () => {
    const isCardFocused = useContext(BoardCardFocusContext);
    return {
        [BOARD_TAB_STOP_ATTRIBUTE]: "",
        tabIndex: isCardFocused ? 0 : -1,
    };
};
